import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { errorBoundary, sendTelemetryErrorEvent } from '~commonInfra/components/ErrorBoundary';
import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { fetchStarterInfoRequestedAction } from '../actions/StartersActions';
import { getStartersGroupedByConnectionType } from './ConnectedStartersChannel';
import { StartersSpace, StartersSpaceDispatchProps, StartersSpaceOwnProps, StartersSpaceStateProps } from './StartersSpace';

const mapStateToProps: MapStateToProps<StartersSpaceStateProps> = (state: AppState) => ({
  startersGroupedByConnectionType: getStartersGroupedByConnectionType(state.starters.starters),
  isBusy: state.starters.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<StartersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  fetchStartersData: fetchStarterInfoRequestedAction,
}, dispatch);

const ConnectedStartersSpaceInternal: React.ComponentClass<StartersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(StartersSpace);
export const ConnectedStartersSpace = errorBoundary<StartersSpaceOwnProps>(sendTelemetryErrorEvent)(ConnectedStartersSpaceInternal);

